














































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import User from '../../../store/entities/user'
import Enums from '@/lib/enums'
@Component
export default class EditUser extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    user: User = new User();
    UserType = Enums.UserType;
    isRole: Boolean = this.hasPermission('Pages.Roles');
    created() {
       
    }
    get roles() {
        return this.$store.state.user.roles;
    }
    haspression() {
       
    }
    save(){
        (this.$refs.userForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'user/update',
                    data:this.user
                });
                (this.$refs.userForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.userForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }else{
            this.user=Util.extend(true,{},this.$store.state.user.editUser);
        }
    }
    userRule={
        userName:[{required: true,message:"账号名称不能为空",trigger: 'blur'}],
        name: [{ required: true, message: "账号名称不能为空", trigger: 'blur' }],
        phone: [
            { required: true, message: this.L('手机号码不能为空'), trigger: 'blur' },
            { pattern: /^1[0-9]{10}$/, message: this.L('请输入正确手机号码'), trigger: 'blur' }
        ],
        weChat: [
            { required: true, message: this.L('微信号码不能为空'), trigger: 'blur' }
        ]
    }

}
